import { ComponentType } from "react";
import { OrganizationOfficeFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/** Офис подразделения — справочное значение. */
export function OrganizationOffice({
  data,
  whenEmpty,
}: {
  data?: Hidable<OrganizationOfficeFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={whenEmpty}>
      {(organization) => (
        <LocalizedName
          data={organization.office?.value}
          whenEmpty={whenEmpty}
        />
      )}
    </Value>
  );
}
